import React from "react";
import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";

import {
  AtSymbolIcon,
  CalendarIcon,
  OfficeBuildingIcon,
  PresentationChartLineIcon,
} from "@heroicons/react/outline";
import { ArrowDown } from "../assets/icons/arrowDownIcon";
import { headerTheme } from "./Header";
import { ForwardArrow } from "../assets/icons";
import { Link } from "gatsby";

export const company = [
  {
    name: "About us",
    href: "/about-us/",
    icon: OfficeBuildingIcon,
    external: false,
  },
  {
    name: "Careers",
    href: "/careers/",
    icon: PresentationChartLineIcon,
    external: false,
  },
  {
    name: "Press",
    href: "/press/",
    icon: CalendarIcon,
    external: false,
  },
  {
    name: "Contact us",
    href: "/contact-us/",
    icon: AtSymbolIcon,
    external: false,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CompanyHeaderButton({
  theme,
  handleEnter,
  handleLeave,
  ref,
  isHover,
  textColor,
  iconColor,
}) {
  return (
    <Popover
      className="relative"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      ref={ref}
    >
      {({ open }) => (
        <>
          <div>
            <Popover.Button
              className={classNames(
                isHover
                  ? headerTheme[theme].hoverTextColor
                  : textColor || headerTheme[theme].textColor,
                "group rounded-md inline-flex gap-2 items-center text-sm lgxl_mid:text-base font-medium focus:outline-none",
              )}
            >
              <span>Company</span>
              <ArrowDown
                fill={
                  isHover
                    ? headerTheme[theme].hoverIcon
                    : iconColor || headerTheme[theme].icon
                }
                className={`transition-transform duration-500 ${
                  isHover ? "rotate-180" : "rotate-0"
                }`}
              />
            </Popover.Button>

            <Transition
              show={isHover}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 -translate-y-1"
              enterTo="opacity-100 translate-y-0"
              null
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="fixed z-10 inset-x-0 mt-[22px] hidden lg:block">
                <div className="w-screen bg-white border-none shadow-neutral-500/10 shadow-md">
                  <div>
                    <nav
                      className="flex bg-white rounded-lg"
                      aria-labelledby="solutions-heading"
                    >
                      <section className="flex-auto bg-white navbar-bg h-auto">
                        <section className="flex gap-1 flex-row max-w-7xl mx-auto px-6 xl:px-16">
                          <section className="flex-1 min-w-[285px] px-6 pb-[22px] md:pr-6 md:pl-0">
                            <p className="px-2 pb-2 pt-[14px] font-medium text-[#AAAAAA]">
                              Company
                            </p>
                            {company.map((item) => (
                              <div key={item.name} className="group">
                                {item.external ? (
                                  <a
                                    href={item.href}
                                    className="p-2 navbar-hover-bg flex items-center gap-2 justify-between group"
                                  >
                                    <div className="flex gap-1.5 items-center">
                                      <p className="text-xl text-gray-2500 group-hover:text-gray-2700 font-medium tracking-tighter_3">
                                        {item.name}
                                      </p>
                                    </div>
                                    <ForwardArrow
                                      fill={"#5E44FF"}
                                      className="opacity-0 group-hover:opacity-100"
                                    />
                                  </a>
                                ) : (
                                  <Link
                                    to={item.href}
                                    className="p-2 navbar-hover-bg flex items-center gap-2 justify-between group"
                                  >
                                    <div className="flex gap-1.5 items-center">
                                      <p className="text-xl text-gray-2500 group-hover:text-gray-2700 font-medium tracking-tighter_3">
                                        {item.name}
                                      </p>
                                    </div>
                                    <ForwardArrow
                                      fill={"#5E44FF"}
                                      className="opacity-0 group-hover:opacity-100"
                                    />
                                  </Link>
                                )}
                              </div>
                            ))}
                          </section>
                        </section>
                      </section>
                    </nav>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </div>
        </>
      )}
    </Popover>
  );
}
